import { useCallback, useMemo } from 'react';

import {
  createSpec,
  specTypes,
  useFetch,
  useDataRefId,
  useRefetch,
} from '@bingads-webui-react/overreact';

import {
  fetchRequestContract,
  fetchResponseContract,
} from '../spec/fetch';
import { environmentLookupFn } from '../../../environment/environment-instance';
import type {
  Account,
  AccountVariables,
  FetchAndRefetchConfig,
  ReadParameters,
  ReadRequestConfig,
} from '../../../types';

const fetchSpec = createSpec(
  fetchRequestContract, fetchResponseContract,
  specTypes.FETCH, null, environmentLookupFn
);
const refetchSpec = createSpec(
  fetchRequestContract, fetchResponseContract,
  specTypes.REFETCH, null, environmentLookupFn
);


export function useCreateExpertFromSmart(
  dataLocator: AccountVariables,
  config: FetchAndRefetchConfig<Account, AccountVariables> = {}
) {
  const dataRefId = useDataRefId(null, environmentLookupFn);
  const defaultConfig = useMemo(() => ({

    fetch: config.fetch || {},

    refetch: config.refetch || {},
  }), [config]);
  const { fetch: fetchConfig, refetch: refetchConfig } = defaultConfig;
  const [data, error] = useFetch(dataRefId, fetchSpec, dataLocator, fetchConfig) as [
    Account | undefined,
    unknown,
  ];

  const refetchFn = useRefetch(dataRefId, refetchSpec, refetchConfig);

  const read = useCallback((
    param: ReadParameters<AccountVariables> = {},
    requestConfig?: ReadRequestConfig<Account, AccountVariables>
  ) => {
    refetchFn({
      variables: { ...dataLocator, ...param.variables },
    }, requestConfig);
  }, [dataLocator, refetchFn]);

  return [{ data, error }, { read }];
}
